import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ListingCategory, SearchType } from '../../classes/enums';
import { Helper } from '../../classes/helper';
import { User } from '../../classes/user';
import { DeviceService } from '../../services/device/device.service';
@Component({
  selector: 'app-site-links',
  templateUrl: './site-links.component.html',
  styleUrls: [
    './site-links.component.scss',
    './site-links.component.desktop.scss'
  ],
})
export class SiteLinksComponent implements OnInit {
  @Input() platform: ListingCategory;
  @Input() totalFavourites: number;
  @Input() faveIcon: string;
  @Input() accountIcon: string;
  @Input() currentUser: User;
  @Input() showMyRemaxMenu: Boolean;
  @Output() onListingsClick: EventEmitter<void> = new EventEmitter();
  @Output() toggleLuxury: EventEmitter<void> = new EventEmitter();
  @Output() toMyRemax: EventEmitter<void> = new EventEmitter();
  @Output() toggleRightNav: EventEmitter<void> = new EventEmitter();
  @Output() closeRightNav: EventEmitter<void> = new EventEmitter();
  @Output() openRegisterLogin: EventEmitter<void> = new EventEmitter();
  @ViewChild('siteLinksRef') siteLinksRef: ElementRef;

  isRealEstateListingsOpen: boolean = false;
  isListingsOpen: boolean = false;
  isBuyingOpen: boolean = false;
  isSellingOpen: boolean = false;
  isFindAnAgentOpen: boolean = false;
  isAboutRemaxOpen: boolean = false;
  isMediaOpen: boolean = false;
  isJoinRemaxOpen: boolean = false;
  isBlogOpen: boolean = false;
  activeSubDropdown: any;
  // enums
  ListingCategory = ListingCategory;
  SearchType = SearchType;
  provinces: Array<{province: string, cities: Array<{name: string, url: string, queryParams?: string}>, active: boolean}> = [
    {active: false, province: 'ab', cities: [
      {name: 'Calgary Real Estate', url: '/ab/calgary-real-estate'},
      {name: 'Edmonton Real Estate', url: '/ab/edmonton-real-estate'},
      {name: 'More Alberta Cities', url: '/real-estate-listings-in-canada', queryParams: 'ab'}
    ]},
    {active: false, province: 'bc', cities: [
      {name: 'Vancouver Real Estate', url: '/bc/vancouver-real-estate'},
      {name: 'Victoria Real Estate', url: '/bc/victoria-real-estate'},
      {name: 'More British Columbia Cities', url: '/real-estate-listings-in-canada', queryParams: 'bc'}
    ]},
    {active: false, province: 'mb', cities: [
      {name: 'Winnipeg Real Estate', url: '/mb/winnipeg-real-estate'},
      {name: 'Brandon Real Estate', url: '/mb/brandon-real-estate'},
      {name: 'More Manitoba Cities', url: '/real-estate-listings-in-canada', queryParams: 'mb'}
    ]},
    {active: false, province: 'nb', cities: [
      {name: 'Moncton Real Estate', url: '/nb/moncton-real-estate'},
      {name: 'Saint John Real Estate', url: '/nb/saint-john-real-estate'},
      {name: 'More New Brunswick Cities', url: '/real-estate-listings-in-canada', queryParams: 'nb'}
    ]},
    {active: false, province: 'nl', cities: [
      {name: `St. John's Real Estate`, url: '/nl/st-john-real-estate'},
      {name: 'Conception Bay South Real Estate', url: '/nl/conception-bay-south-real-estate'},
      {name: 'More Newfoundland and Labrador Cities', url: '/real-estate-listings-in-canada', queryParams: 'nl'}
    ]},
    {active: false, province: 'nt', cities: [
      {name: 'Yellowknife Real Estate', url: '/nt/yellowknife-real-estate'},
      {name: 'Hay River Real Estate', url: '/nt/hay-river-real-estate'},
      {name: 'More Northwest Territories Cities', url: '/real-estate-listings-in-canada', queryParams: 'nt'}
    ]},
    {active: false, province: 'ns', cities: [
      {name: 'Halifax Real Estate', url: '/ns/halifax-real-estate'},
      {name: 'Cape Breton Real Estate', url: '/ns/cape-breton-real-estate'},
      {name: 'More Nova Scotia Cities', url: '/real-estate-listings-in-canada', queryParams: 'ns'}
    ]},
    {active: false, province: 'nu', cities: [
      {name: 'Iqaluit Real Estate', url: '/nu/iqaluit-real-estate'},
      {name: 'Rankin Inlet Real Estate', url: '/nu/rankin-inlet-real-estate'},
      {name: 'More Nunavut Cities', url: '/real-estate-listings-in-canada', queryParams: 'nu'}
    ]},
    {active: false, province: 'on', cities: [
      {name: 'Toronto Real Estate', url: '/on/toronto-real-estate'},
      {name: 'Ottawa Real Estate', url: '/on/ottawa-real-estate'},
      {name: 'More Ontario Cities', url: '/real-estate-listings-in-canada', queryParams: 'on'}
    ]},
    {active: false, province: 'pe', cities: [
      {name: 'Charlottetown Real Estate', url: '/pe/charlottetown-real-estate'},
      {name: 'Summerside Real Estate', url: '/pe/summerside-real-estate'},
      {name: 'More Prince Edward Island Cities', url: '/real-estate-listings-in-canada', queryParams: 'pe'}
    ]},
    {active: false, province: 'sk', cities: [
      {name: 'Saskatoon Real Estate', url: '/sk/saskatoon-real-estate'},
      {name: 'Regina Real Estate', url: '/sk/regina-real-estate'},
      {name: 'More Saskatchewan Cities', url: '/real-estate-listings-in-canada', queryParams: 'sk'}
    ]},
    {active: false, province: 'yt', cities: [
      {name: 'Whitehorse Real Estate', url: '/yt/whitehorse-real-estate'},
      {name: 'Dawson Real Estate', url: '/yt/dawson-real-estate'},
      {name: 'More Yukon Cities', url: '/real-estate-listings-in-canada', queryParams: 'yt'}
    ]},
  ];

  constructor(private deviceService: DeviceService) { }

  ngOnInit() { }

  getCityUrl(url: string) {
    if (url.indexOf('real-estate-listings-in-canada') !== -1) return url;
    return Helper.getUrlForCategory(url, this.platform);
  }

  toggleProvinceMenu( province: any, evt?, parentDropdown?) {
    this.isRealEstateListingsOpen = true;
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      // Disable event on mobile devices to prevent mouseEnter event
      if (this.shouldDisableMouseEnter(evt)) {
        return;
      }
    }

    if (province.active ) {
      province.active = !province.active;
      return;
    }

    const index = this.provinces.findIndex(g => g.active);

    if (index !== -1) {
      this.provinces[index].active = false;
    }
    province.active = !province.active;
  }

  toggleDropdown(type: string, $event: Event, focusableElement?) {
    if ($event) {
      $event.stopPropagation();
      if (this.shouldDisableMouseEnter($event)) {
        return;
      }
    }

    setTimeout(() => {

      if (type) {
        switch (type) {
          case 'isRealEstateListingsOpen': {
            this.isRealEstateListingsOpen = !this.isRealEstateListingsOpen;
            break;
          }
          case 'isBuyingOpen': {
            this.isBuyingOpen = !this.isBuyingOpen;
            break;
          }
          case 'isSellingOpen': {
            this.isSellingOpen = !this.isSellingOpen;
            break;
          }
          case 'isFindAnAgentOpen': {
            this.isFindAnAgentOpen = !this.isFindAnAgentOpen;
            break;
          }
          case 'isAboutRemaxOpen': {
            this.isAboutRemaxOpen = !this.isAboutRemaxOpen;
            break;
          }
          case 'isMediaOpen': {
            this.isMediaOpen = !this.isMediaOpen;
            break;
          }
          case 'isJoinRemaxOpen': {
            this.isJoinRemaxOpen = !this.isJoinRemaxOpen;
            break;
          }
          case 'isBlogOpen': {
            this.isBlogOpen = !this.isBlogOpen;
            break;
          }
        }
      }
    });

    this.isRealEstateListingsOpen = type === 'isRealEstateListingsOpen' && this.isRealEstateListingsOpen;
    this.isBuyingOpen = type === 'isBuyingOpen' && this.isBuyingOpen;
    this.isSellingOpen = type === 'isSellingOpen' && this.isSellingOpen;
    this.isFindAnAgentOpen = type === 'isFindAnAgentOpen' && this.isFindAnAgentOpen;
    this.isAboutRemaxOpen = type === 'isAboutRemaxOpen' && this.isAboutRemaxOpen;
    this.isMediaOpen = type === 'isMediaOpen' && this.isMediaOpen;
    // Checking if Join Remax dropdown is opened
    this.isJoinRemaxOpen = type === 'isJoinRemaxOpen' && this.isJoinRemaxOpen;
    this.isBlogOpen = type === 'isBlogOpen' && this.isBlogOpen;




    if (focusableElement) {
      setTimeout(() => focusableElement.focus());
    }
  }

  clearProvinceMenus() {
    this.provinces.forEach(province => {
      province.active = false;
    })
  }

  @HostListener('window:mouseover', ['$event'])
  onPageHover($event: MouseEvent) {
    // Hide all the dropdowns if the dropdowns are open and they hover something not a dropdown
    // Added the isJoinRemax to below if statement to hide Join Remax dropdown on element outside click
    if ((this.isAboutRemaxOpen || this.isBuyingOpen || this.isRealEstateListingsOpen ||
      this.isFindAnAgentOpen ||  this.isMediaOpen ||
      this.isSellingOpen || this.isJoinRemaxOpen) &&
      !(this.siteLinksRef.nativeElement).contains($event.toElement)) this.toggleDropdown(null, $event);
  }

  readonly showStyles = {
    opacity: 1,
    visibility: 'visible',
    height: '100%'
  }

  readonly hideStyles = {
    opacity: 0,
    display: 'none',
    height: '0'
  }

  focusNext(event: KeyboardEvent) {
    try {
      if (event.target['parentElement'].nextElementSibling.firstChild) {
        event.preventDefault();
        event.target['parentElement'].nextElementSibling.firstChild.focus();
      }
    } catch (err) {
      console.error(err);
    }
  }

  focusPrevious(event: KeyboardEvent) {
    try {
      if (event.target['parentElement'].previousElementSibling.firstChild) {
        event.preventDefault();
        event.target['parentElement'].previousElementSibling.firstChild.focus();
      }
    } catch (err) {
      console.error(err);
    }
  }

  // Function to disable mouseEnter if device is mobile
  shouldDisableMouseEnter($event: Event): boolean {
    return $event && $event.type === 'mouseenter' && this.deviceService.isMobileDevice(); 
  }
}
